import {getGameConfigurationImagePath} from "../../../games/utils/game-image-url";

export const hasUnnormalizedGameConfigurationImages = gameSettings =>
    Array.isArray(gameSettings) &&
    gameSettings.some(gameSetting => {
        const configuration = gameSetting && gameSetting.configuration;
        const configImage = configuration && configuration.config_image;

        if (!configImage || gameSetting.config_id == null) return false;

        return (
            configImage !==
            getGameConfigurationImagePath(
                gameSetting.config_id,
                configImage
            )
        );
    });

export const buildGameSetting = (instance, gameConfigurations) => {
    const gameConfiguration = gameConfigurations[instance.id];

    return {
        id: instance.identifier,
        config_id: gameConfiguration.id,
        name: gameConfiguration.label,
        image:
            gameConfiguration.image !== undefined &&
            gameConfiguration.image !== null
                ? gameConfiguration.image
                : instance.game.image !== undefined
                ? instance.game.image
                : null,
        software_house: instance.game.software_house["name"],
        type: instance.game.type,
        version: "1",
        configuration: {
            ...(gameConfiguration.configuration || {}),
            ...(gameConfiguration.category
                ? {category: gameConfiguration.category.id}
                : {}),
            config_image:
                getGameConfigurationImagePath(
                    gameConfiguration.id,
                    instance.image
                ) || null
        },
        trademark: instance.game.trademark
            ? {
                  id: instance.game.trademark.trademark_id,
                  name: instance.game.trademark.name
              }
            : null,
        series: instance.game.series
            ? {
                  id: instance.game.series.series_id,
                  name: instance.game.series.name
              }
            : null,
        feature: instance.game.feature
            ? {
                  id: instance.game.feature.feature_id,
                  name: instance.game.feature.name
              }
            : null,
        platform: instance.game.platform
            ? {
                  id: instance.game.platform.platform_id,
                  name: instance.game.platform.name
              }
            : null,
        game_type: instance.game.game_type
            ? {
                  id: instance.game.game_type.type_id,
                  name: instance.game.game_type.name
              }
            : null
    };
};
